import { Box, chakra, shouldForwardProp, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { COMMON_WEB_PATH } from "../../../constant";
import Count from "../../../pages/WebSocket/components/Count";
import JackpotNumber from "./JackpotNumber";
import { isValidMotionProp, motion, useSpring } from "framer-motion";
import { formatNumber } from "../../../utils/formatNumber";
import { specialTextGradientStyle } from "../../../utils/specialTextGradientStyle";

const splitNumber = (num) => {
  const numStr = formatNumber(num, { point: false }).toString();
  const cleanStr = numStr.replace(/,/g, "");
  const digitCount = cleanStr.length;

  const digits = numStr.split("");
  const units = [];

  let digitIndex = 0;

  for (const ch of digits) {
    if (ch === ",") {
      units.push("");
    } else {
      const exponent = digitCount - digitIndex - 1;
      units.push(Math.pow(10, exponent));
      digitIndex++;
    }
  }
  return {
    digits: digits,
    units: units,
  };
};
const JackpotItem = ({
  type,
  w,
  h,
  pb,
  fontSize,
  wrapperW,
  wrapperH,
  inset,
  pt,
} = {}) => {
  const [amount, setAmount] = useState(3009);
  const animatedValue = useSpring(amount);

  useEffect(() => {
    animatedValue.set(amount);
  }, [amount, animatedValue]);

  const { digits, units } = splitNumber(amount);

  useEffect(() => {
    const interval = setInterval(() => {
      setAmount((prev) => prev + Math.floor(48));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      bgImage={`url(${COMMON_WEB_PATH}/now888/jackpot/${type}.png)`}
      bgSize={"100% 100%"}
      w={
        w || {
          base: "150px",
          md: "150px",
        }
      }
      maxW="300px"
      h={
        h || {
          base: "65px",
          md: "65px",
        }
      }
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      pt={pt || "20px"}
      pb={pb || 0}
    >
      <Box
        display="flex"
        alignItems={"center"}
        justifyContent={"center"}
        h={wrapperH || "16.5px"}
        w="100%"
      >
        {digits?.map((digit, index) => {
          const isLastNumber = index === digits.length - 1;
          return (
            <Box
              position={"relative"}
              w={
                wrapperW || {
                  base: "15px",
                  md: "22px",
                  xl: "15px",
                }
              }
              h="100%"
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              overflow="hidden"
            >
              {digit == "," ? (
                <Box
                  position={"absolute"}
                  inset={
                    inset || {
                      base: "-12px 0px 0px 0px",
                      md: "-14px 0px 0px 0px",
                    }
                  }
                  display={"flex"}
                  justifyContent={"center"}
                  sx={specialTextGradientStyle}
                  color={"transparent"}
                  fontWeight={900}
                  fontSize={
                    fontSize || {
                      base: "20px",
                      md: "26px",
                    }
                  }
                >
                  {","}
                </Box>
              ) : (
                [...Array(10).keys()].map((i) => {
                  return (
                    <JackpotNumber
                      place={units[index]}
                      mv={animatedValue}
                      isLastNumber={isLastNumber}
                      number={i}
                      key={i}
                      fontSize={fontSize}
                      inset={inset}
                    />
                  );
                })
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default JackpotItem;
